import { FormControl, GlobalStyles, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { Stack } from "@mui/system";
import queryString from "query-string";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { back, init, selected } from "../../redux/actions/webEvaluation1";
import Footer from "../common/Footer";
import Header from "../common/Header";

export default function WebEvaluation1() {
  const imageRefs = useRef({});

  const dispatch = useDispatch();
  const itemName = useSelector((state) => state.webEvaluation1.itemName);
  const categoryName = useSelector((state) => state.webEvaluation1.categoryName);
  const grade = useSelector((state) => state.webEvaluation1.grade);
  const gradeRange = useSelector((state) => state.webEvaluation1.gradeRange);
  const classNumber = useSelector((state) => state.webEvaluation1.classNumber);
  const number = useSelector((state) => state.webEvaluation1.number);
  const name = useSelector((state) => state.webEvaluation1.name);
  const title = useSelector((state) => state.webEvaluation1.title);
  const imageE = useSelector((state) => state.webEvaluation1.imageE);
  const imageD = useSelector((state) => state.webEvaluation1.imageD);
  const imageC = useSelector((state) => state.webEvaluation1.imageC);
  const imageB = useSelector((state) => state.webEvaluation1.imageB);
  const imageA = useSelector((state) => state.webEvaluation1.imageA);
  const imageS = useSelector((state) => state.webEvaluation1.imageS);
  const itemId = useSelector((state) => state.webEvaluation1.itemId);
  const roleId = useSelector((state) => state.auth.user.roleId);

  // Mapping of grade numbers to labels and stickerIds
  const gradeMapping = [
    { value: 1, label: "S", stickerId: "01", image: imageS },
    { value: 2, label: "A", stickerId: "02", image: imageA },
    { value: 3, label: "B", stickerId: "03", image: imageB },
    { value: 4, label: "C", stickerId: "04", image: imageC },
    { value: 5, label: "D", stickerId: "05", image: imageD },
    { value: 6, label: "E", stickerId: "06", image: imageE },
  ];

  // Filter grade options based on gradeRange
  const gradeOptions = gradeRange
    ? gradeMapping.filter(
      (grade) => grade.value >= gradeRange.start && grade.value <= gradeRange.end
    )
    : gradeMapping; // Fallback to all grades if gradeRange is not available

  // Initialize URL parameters
  useEffect(() => {
    const currentUrl = window.location.href;
    const parsedUrl = queryString.parseUrl(currentUrl);
    const { serialNumber, grade, classNumber, number, name, listId, termId } =
      parsedUrl.query;

    const param = {
      serialNumber,
      grade,
      classNumber,
      number,
      name,
      listId,
      termId,
    };
    dispatch(init(param));
  }, [dispatch]);

  // Add event listeners for images within gradeRange
  useEffect(() => {
    if (itemId) {
      gradeOptions.forEach((option) => {
        const ref = imageRefs.current[option.label];
        if (ref) {
          ref.addEventListener("click", submitEvaluation);
        }
      });

      return () => {
        gradeOptions.forEach((option) => {
          const ref = imageRefs.current[option.label];
          if (ref) {
            ref.removeEventListener("click", submitEvaluation);
          }
        });
      };
    }
  }, [itemId, gradeOptions]);

  const submitEvaluation = (param) => {
    const stickerId = param.target.getAttribute("data-value");

    const currentUrl = window.location.href;
    const parsedUrl = queryString.parseUrl(currentUrl);
    const { serialNumber, listId, termId } = parsedUrl.query;

    // Remove all event listeners
    gradeOptions.forEach((option) => {
      const ref = imageRefs.current[option.label];
      if (ref) {
        ref.removeEventListener("click", submitEvaluation);
      }
    });

    dispatch(
      selected({ serialNumber, listId, termId, itemId, stickerId })
    );
  };

  const submitBack = () => {
    const currentUrl = window.location.href;
    const parsedUrl = queryString.parseUrl(currentUrl);
    const { serialNumber, listId, termId } = parsedUrl.query;

    dispatch(back({ serialNumber, listId, termId }));
  };

  const submitBackMenu = () => {
    if (roleId === 2) {
      window.location.href = "/EvaluationImplement";
    } else if (roleId === 3) {
      window.location.href = "/StudentMenu";
    }
  };

  const [buttonText, setButtonText] = useState("");

  React.useEffect(() => {
    if (roleId === 2) {
      setButtonText("検索画面へ戻る");
    } else if (roleId === 3) {
      setButtonText("メニューへ戻る");
    }
  }, [roleId]);

  return (
    <Box>
      <GlobalStyles
        styles={{
          body: { backgroundColor: "#fff176" },
        }}
      />
      <Header />
      <Box
        sx={{
          m: 1.5,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <FormControl fullWidth>
          <Typography component="h5" variant="h6" align="left">
            対象生徒氏名：{grade + "-" + classNumber + "-" + number + " " + name}
          </Typography>
        </FormControl>
        <FormControl fullWidth sx={{ mt: 1 }}>
          <Typography component="h5" variant="h6" align="left">
            {title}について評価を行う
          </Typography>
        </FormControl>
        <FormControl fullWidth sx={{ mt: 2, mb: 3 }}>
          <Typography component="h8" variant="h5">
            【{categoryName}】{itemName}
          </Typography>
        </FormControl>
      </Box>

      <Grid container spacing={0} sx={{ p: 2 }} justifyContent="center" alignItems="center">
        {gradeOptions.map((option) => (
          <Grid item xs={2} key={option.label}>
            <Box sx={{ bgcolor: "#b3e5fc" }}>
              <Typography
                component="h5"
                variant="h4"
                sx={{ border: "solid 1px #37474f" }}
              >
                {option.label}
              </Typography>
              <FormControl sx={{ boxSizing: "border-box", border: "solid 1px #37474f", width: "100%", aspectRatio: "353/500", justifyContent: "center", alignItems: "center" }}>
                <img
                  src={`./neqst/images/${option.image}`}
                  width="100%"
                  height="100%"
                  ref={(el) => (imageRefs.current[option.label] = el)}
                  data-value={option.stickerId}
                />
              </FormControl>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ m: 2, display: "flex" }}>
        <Stack direction="row" spacing={5} marginRight="auto">
          <Button
            variant="contained"
            size="medium"
            onClick={submitBackMenu}
            sx={{ bgcolor: "#82b1ff" }}
          >
            {buttonText}
          </Button>
          <Button
            variant="contained"
            size="medium"
            onClick={submitBack}
            sx={{ bgcolor: "#82b1ff", marginLeft: "auto" }}
          >
            戻る
          </Button>
        </Stack>
      </Box>

      <Footer />
    </Box>
  );
}